import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { AllocationPeriodType } from '~/types';
import { useBulkAcceptAllocationsForResourceRequest } from '~/modules/resourcing/common/hooks';
import useResourceAllocationToolbarStateContext from '~/modules/resourcing/hooks/useResourceAllocationToolbarStateContext';
import ShowSmartFitDialogOrLoading2 from '~/modules/resourcing/components/ResourceAssignmentDialog/components/ResourceUsersChartPanel/components/ShowSmartFitDialogOrLoading/ShowSmartFitDialogOrLoading2';

const AcceptWithSmartFitDialog = ({ smartFitState, onClose }) => {
  const { resourceRequest, resourceUser, allocationChartRef } = smartFitState;

  const {
    bulkAcceptAllocationsForResourceRequest
  } = useBulkAcceptAllocationsForResourceRequest();

  const { scale } = useResourceAllocationToolbarStateContext() || {};

  const allocationDateRange = useMemo(
    () => ({
      startDate: resourceRequest.startDate,
      endDate: resourceRequest.endDate
    }),
    [resourceRequest]
  );

  const totalAllocatedHours = resourceRequest.totalHours;

  const acceptAllocation = useCallback(
    (_overrideScheduleRules, distributionMode) => {
      bulkAcceptAllocationsForResourceRequest({
        acceptAllocationInput: [
          {
            resourceRequestId: resourceRequest.id,
            userIds: [resourceUser.id],
            ...(distributionMode && {
              allocationHoursInDateRangeInput: {
                dateRange: allocationDateRange,
                hoursPerPeriod: totalAllocatedHours,
                periodType: AllocationPeriodType.EntireRange,
                distributionMode
              }
            })
          }
        ],
        allocationChartRef
      });
      onClose();
    },
    [
      bulkAcceptAllocationsForResourceRequest,
      resourceRequest.id,
      resourceUser.id,
      allocationDateRange,
      totalAllocatedHours,
      allocationChartRef,
      onClose
    ]
  );

  return (
    <ShowSmartFitDialogOrLoading2
      resourceUser={resourceUser}
      totalAllocatedHours={totalAllocatedHours}
      allocationDateRange={allocationDateRange}
      createAllocationWithUserAndOverrideRules={acceptAllocation}
      closeShowSmartFitDialogOrLoading={onClose}
      scale={scale}
    />
  );
};

AcceptWithSmartFitDialog.propTypes = {
  smartFitState: PropTypes.shape({
    resourceRequest: PropTypes.object.isRequired,
    resourceUser: PropTypes.object.isRequired,
    allocationChartRef: PropTypes.object
  }).isRequired,
  onClose: PropTypes.func.isRequired
};

export default AcceptWithSmartFitDialog;
